import React from 'react';
import { Grid } from '@material-ui/core';

const Account = () => (
    <Grid item>
        Account
    </Grid>
);

export default Account;
